export default {
    statusEndosso: {
        SALVO: 1,
        EMITIDA: 2,
        AG_ENDOSSO: 3, 
        ENDOSSO_APROVADO: 4,
        ENDOSSO_REPROVADO: 5,
        ENDOSSO_CANCELADO: 7,
        PENDENTE: 8,
        RECUSADO: 9
    }
  }


// WEBPACK FOOTER //
// ./src/helpers/status-endosso-enum.js